import { createFileRoute } from "@tanstack/react-router";
import { NotFoundPage } from "@/features/error/NotFoundPage";

export const Route = createFileRoute("/404")({
  component: NotFoundPage,
});
